import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect } from "react";
import getUrl from "../requests/getUrl";
import logo from "../assets/Logo_SAT_SAT_3.png"

export default function Sidebar() {
    const navigate = useNavigate();

    const isSessionValid = async () => {
        const expires = await fetchSessionExpiry();

        if (!expires) {
            return false;
        }

        // Convert expires string to Date object
        const expiresDate = new Date(expires);

        // Current time in GMT
        const nowGMT = new Date();


        // Compare dates as Date objects
        return expiresDate > nowGMT;
    };

    const fetchSessionExpiry = async () => {
        try {
            const res = await fetch(getUrl()+"/api/login/session/expiry", {
                method: "GET",
                credentials: "include",
            });
            if (res.status === 401) {
                return false;
            }
            if (!res.ok) {
                throw new Error(`Error fetching session expiry: ${res.status}`);
            }

            const data = await res.json();
            return data.expires_by;
        } catch (err) {
        }
    };

    function deleteSessionCookies() {
        const cookiesToRemove = ["SESSIONID", "SESSION_EXPIRES"]; // Replace with your cookie names

        // Remove each cookie by name
        cookiesToRemove.forEach(cookieName => {
            Cookies.remove(cookieName); // Remove cookie
        });
    }

    useEffect(() => {
        async function checkSessionExpiry() {
            let sessionValid = await isSessionValid();
            if (!sessionValid) {
                deleteSessionCookies();
                navigate("/login");
            }
        }

        checkSessionExpiry(); // Check session expiry immediately when the component mounts

        // Set interval to check session expiry every minute
        const intervalId = setInterval(() => {
            checkSessionExpiry();
        }, 60000); // 60000 ms = 1 minute

        // Cleanup the interval when the component unmounts
        return () => clearInterval(intervalId);

    }, [navigate]);

    return (
        <div className="sidebar-wrapper">
            <div className="sidebar-body">
                <nav>
                    <div className="">
                        <div className=" nav-container">
                            <div className="menu-items">
                                <div className="sidebar-logo-wrapper">
                                    <img
                                        className="logo"
                                        src={logo}
                                    />
                                    {/*<span className="sidebar-logo">SAT</span>*/}
                                    {/*<span className="sidebar-sublogo">Delivery</span>*/}
                                </div>
                                <li className="sidebar-highlighted">
                                    <Link to={'/home'} className="sidebar-menu-item">
                                        Home
                                    </Link>
                                </li>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    );
}
